export function formatProfiles(profiles = []) {
  return profiles.map(profile => ({
    label: `${profile.firstName} ${profile.lastName}`,
    value: profile.id
  }));
}

export default {
  formatProfiles
};
